import { drawFretboard, NOTE_RADIUS, createFretboardConfig } from './draw.js';
import { notes } from './notes.js';
export let currentNote;
let previousNote;
export let showingAnswer = false;
let canvas;
let ctx;
let config;
function nextNote() {
    previousNote = currentNote;
    currentNote = notes[chooseNote()];
    while (currentNote === previousNote) {
        currentNote = notes[chooseNote()];
    }
    showingAnswer = false;
    drawFretboard(ctx, canvas, currentNote, showingAnswer);
    function chooseNote() {
        return Math.floor(Math.random() * notes.length);
    }
}
function showNote() {
    showingAnswer = true;
    drawFretboard(ctx, canvas, currentNote, showingAnswer);
}
// Calculate note position on canvas
function getNotePosition(note) {
    const stringIndex = config.numStrings - note.string;
    const fretIndex = note.fret;
    const x = config.padding + stringIndex * config.stringSpacing;
    let y;
    if (fretIndex === 0) {
        y = config.padding - 15;
    }
    else {
        y = config.padding + fretIndex * config.fretSpacing - config.fretSpacing / 2;
    }
    return { x, y };
}
async function handleCanvasClick(clientX, clientY) {
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    const clickX = (clientX - rect.left) * scaleX;
    const clickY = (clientY - rect.top) * scaleY;
    const notePos = getNotePosition(currentNote);
    const distance = Math.sqrt(Math.pow(clickX - notePos.x, 2) + Math.pow(clickY - notePos.y, 2));
    if (distance < NOTE_RADIUS * 1.5) {
        showNote();
        await new Promise((resolve) => setTimeout(resolve, 1000));
        nextNote();
    }
    else {
        nextNote();
    }
}
function init() {
    const canvasEl = document.getElementById('fretboard');
    canvas = canvasEl;
    ctx = canvas.getContext('2d');
    config = createFretboardConfig(canvas);
    canvas.addEventListener('click', (e) => {
        handleCanvasClick(e.clientX, e.clientY);
    });
    nextNote();
}
if (typeof document !== 'undefined') {
    init();
}
